import get from 'lodash/get';
import queryString from 'query-string';

export const getAttachmentURL = (url = '') => {
  const [uri, search] = (url || '').split('?');
  const enrichedSearch = queryString.stringify({
    ...queryString.parse(search),
    access_token: get(
      JSON.parse(localStorage.getItem('state')),
      'user.accessToken',
    ),
  });

  return (url || '').indexOf(';base64') > -1 ? url : `${uri}?${enrichedSearch}`;
};

export default getAttachmentURL;
